import React from 'react';
import { View, StyleSheet, Platform, Dimensions } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import memoize from 'memoize-one';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import Shimmer from '../Shimmer';
import { withTheme, LightThemeColors } from '../Themes';
import VFTouchableInScroll from '../VFTouchableInScroll';

import styles from './Card.styles.js';

import ReduxCache from '../../../../../App/Utils/ReduxCache'

function getProperCardStyle(type, style, showAction, hasShadow, theme) {
  if (type === 'addMore' && showAction) {
    return StyleSheet.flatten([styles[type](theme, hasShadow), styles.withAddButton, style]);
  } else if (type === 'addMore' || type === 'main' || type === 'sec') {
    return StyleSheet.flatten([styles[type](theme, hasShadow), style]);
  }
  return StyleSheet.flatten([styles[type], style]);
}

const getProperCardStyleMemoized = memoize(getProperCardStyle);

const Card = ({
  type,
  showAction,
  children,
  componentName,
  onPressCard,
  style,
  hasShadow,
  accessibilityLabel,
  loadingConfig,
  shimmerPlaceholderConfig,
  isLoading,
  cardAccessible,
  theme,
  isFourthCard,
  ...props
}) => {
  const cardStyle = getProperCardStyleMemoized(type, style, showAction, hasShadow, theme);

  const userType = ReduxCache.getUserType()

  return (
    <VFTouchableInScroll
      onPress={() => onPressCard(componentName, props)}
      accessible={cardAccessible}
      accessibilityLabel={accessibilityLabel}
      testID={accessibilityLabel}
    >
      <View style={[
        cardStyle,
        { marginRight: Platform.OS === 'web' && Dimensions.get('window').width > 700 && type !== 'sec' && isFourthCard === false ? 20 : null }, userType === 'prepaid_fix' && type === 'main' ? { elevation: 0, marginRight: 0, shadowOffset: { width: 0, height: 0 }, shadowRadius: 0 } : {}]} {...props}>
        {isLoading ? (
          <View style={styles.shimmerContainer} testID={FoundationTestKeys.cardLoadingView}>
            <Shimmer config={loadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
          </View>
        ) : (
          children
        )}
      </View>
    </VFTouchableInScroll >
  );
};

Card.defaultProps = {
  onPressCard: () => { },
  hasShadow: true,
  theme: LightThemeColors,
  cardAccessible: false,
};

Card.propTypes = {
  style: ViewPropTypes.style,
  type: PropTypes.any,
  showAction: PropTypes.bool,
  children: PropTypes.node,
  componentName: PropTypes.string,
  onPressCard: PropTypes.func,
  hasShadow: PropTypes.bool,
  accessibilityLabel: ViewPropTypes.accessibilityLabel,
  loadingConfig: PropTypes.array,
  shimmerPlaceholderConfig: PropTypes.object,
  isLoading: PropTypes.bool,
  cardAccessible: PropTypes.bool,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export { getProperCardStyle };

export default withTheme(Card);
